/**
 * The artboard's chevron on a card or a row that leads somewhere, pointing on (Main's next visit),
 * in the brand's navy: Home's next visit, and each row under On its way and Paid on Payments.
 */
export function Onward() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="shrink-0 text-text-brand"
    >
      <path d="M7.5 4.5 13 10l-5.5 5.5" />
    </svg>
  );
}

/**
 * The chevron on a way back, pointing back, in the ink of the link it is drawn in: Account's own
 * pages' "Back to Account", and "Home" over one visit's report (States-HomeA "4. Photos from a
 * visit", home #21).
 */
export function Backward() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      <path d="M12.5 4.5 7 10l5.5 5.5" />
    </svg>
  );
}

/**
 * The chevron on a button that folds something away and opens it again, pointing down while it is
 * folded: "Ways to pay this invoice" and "How do I use Zelle?" on an invoice's own page.
 */
export function Chevron({ open }: { readonly open: boolean }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={open ? 'shrink-0 rotate-180' : 'shrink-0'}
    >
      <path d="M5 7.5 10 12.5 15 7.5" />
    </svg>
  );
}
